
//
// Current build version
// Note: Do not change this file manually, it's overridden by esbuild
//
export const EdstartVersion = {
  "buildHash": "09f743a45fe35dcf14e3a3ddec8b000b51576320",
  "buildsTs": "2023-02-17_085300"
}
